import { AfterViewInit, Component, Inject } from '@angular/core';
import { annexItems, socialMedia, websiteItems } from './configs/contact-config';
import { NavItem } from '@libs/models/nav-item.interface';
import { navItems } from './configs/nav-items';
import { IAnnex, IContact, ISocial } from '@libs/models/models';
import { IItem } from '@libs/shared/components/stepper-widget/stepper-widget.component';
import { CommonService } from '@libs/services/common.service';
import { UnsubscribeService } from '@libs/shared/services/unsubscribe.service';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from '@libs/shared/injections/window';
import { EnvironmentType } from '@libs/models/environment.type';
import { ClarityHelper } from '@libs/helpers/clarity.helper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  providers: [UnsubscribeService],
})
export class AppComponent implements AfterViewInit {
  public isWebSite$: Observable<boolean> = this.commonService?.isWebSite;
  public readonly navItems: NavItem[] = navItems;
  public phones: IContact[] = this.environment.PHONES;
  public emails: IContact[] = this.environment.EMAILS;
  public readonly websiteItems: NavItem[] = websiteItems;
  public readonly annex: IAnnex[] = annexItems;
  public social: ISocial[] = socialMedia;

  public steps: IItem[] = [
    { url: '/form/profile', text: 'nav.profile' },
    { url: '/form/busyness', text: 'nav.INCOME' },
    { url: '/card/confirm', text: 'nav.CONFIRM_CARD' },
  ];

  constructor(
    private commonService: CommonService,
    @Inject(ENVIRONMENT) private environment: EnvironmentType,
    private clarityHelper: ClarityHelper,
  ) {}

  public ngAfterViewInit(): void {
    this.commonService.initHelpersScripts();
    this.clarityHelper.initFirstSessionEvent();
  }
}
